<template>
  <div class="confirm">
    <div class="com-title c-title">
      确认收货地址
      <span>
        <router-link class="deta" :to="'/shop-address'">
          管理收货地址
        </router-link>
      </span>
    </div>
    <template v-if="this.table.list.length === 0 || this.table.list === null || this.table.list === undefined">
      <el-dialog title="提示" width="175px" :visible.sync="dialogAdd" center="">
        <div style="text-align: center;font-size: 18px">收货地址为空</div>
        <el-button type="primary" @click="add" style="margin-top: 30px">添加收货地址</el-button>
      </el-dialog>
    </template>
    <div class="c-add" v-else>
      <div class="c-text">寄送至：</div>
      <div class="c-wrap">
        <template v-for="(item, index) in showList">
          <div class="c-con">
            <div class="con">
              <el-radio v-model="radio" :label="index" @change.native="getTime(index)">
                <span>{{item.province}}</span>
                <span>{{item.city}}</span>
                <span>{{item.area}}</span>
                <span>{{item.street}}</span>
                <span>( {{item.name}} 收 )</span>
                <span>{{item.mobile}}</span>
              </el-radio>
            </div>
            <div class="handle">
              <el-button type="text" size="small" v-if="!(item.isDefault === 1)" @click="setDefault(index)">
                设为默认地址
              </el-button>
              <el-button type="text" size="small" v-else>默认地址</el-button>
              <el-button type="text" size="small" @click="handleClick(index, item)">修改</el-button>
            </div>
          </div>
        </template>
        <div @click="showAll = !showAll" class="show-more" v-if="this.table.list.length > 2">{{ word }}</div>
      </div>
    </div>
    <div class="new-add" @click="close()">+ 使用新地址</div>
    <el-dialog width="677px" :visible.sync="dialogVisible">
      <ComAddress :data="formDate" :edit="editFlag" @edit="handleEdit"></ComAddress>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="convertVisible"
      center
      width="350px"
      :before-close="handleClose">
      <el-dialog
        class="dia-title"
        title="填写信息让您的专属客服帮您"
        :visible.sync="dialog"
        center
        append-to-body
        width="690px"
        height="460px">
        <div class="message">
          <el-form :model="form" ref="formModifyRow" :rules="rules">
            <el-form-item :rules="{required: true, message: '不能为空', trigger: ['blur', 'change']}" prop="enterpriseName">
              <el-input
                v-model="form.enterpriseName"
                placeholder="企业名称（必填）"
                class="message-inp"
              ></el-input>
            </el-form-item>
            <el-form-item prop="name" :rules="{required: true, message: '不能为空', trigger: ['blur', 'change']}">
              <el-input
                v-model="form.name"
                placeholder="姓名（必填）"
                class="message-inp"
              ></el-input>
            </el-form-item>
            <el-form-item prop="telephone" :rules="[{required: true, message: '请输入手机号', trigger: ['blur', 'change']},
                {pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '格式不正确'}]">
              <el-input
                v-model="form.telephone"
                placeholder="联系电话（必填）"
                class="message-inp"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="message-btn"  @click="submitRow()">立即提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <div style="font-size: 20px;text-align: center">确定兑换？</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="convertVisible = false">取 消</el-button>
        <el-button type="primary" @click="verifyOrder">确 定</el-button>
      </span>
    </el-dialog>
    <div class="c-order">
      <div class="com-title">
        确认订单信息
      </div>
      <div class="c-msg">
        <ul class="msg-title">
          <li>商品属性</li>
          <li>单价</li>
          <li>数量</li>
          <li>小计</li>
        </ul>
        <ul class="msg-con">
          <li>
            <div class="msg-pic">
              <img :src="detail.productPics" alt="">
            </div>
            <div class="msg-text">
              {{detail.title}}
            </div>
          </li>
          <li>{{detail.exchangeScore}}</li>
          <li>
            <el-input-number size="small" v-model="num" @change="handleChange" :min="1"
                             :max="detail.stock"></el-input-number>
            <div class="tig" v-if="num >= detail.stock">不能大于库存数量</div>
            <div class="repertory" v-else>( 库存 {{detail.stock}} )</div>
          </li>
          <li>{{detail.exchangeScore * num}}</li>
          <li>配送方式：普通配送快递</li>
          <li>0.00</li>
        </ul>
        <ol class="msg-foot">
          <li>配送至：</li>
          <li>
            <span>{{address}}</span>
          </li>
          <li>
            消耗渠道积分：
            <span>{{detail.exchangeScore * num}}</span>
          </li>
        </ol>
        <button class="msg-btn" @click="addOrder">提交订单</button>
      </div>
    </div>
  </div>
</template>

<script>
  import Api from '@/api/client/shop-address'
  import goodApi from '@/api/customer-good'
  import scoreApi from '@/api/client/task-wall'
  import { AddFormArgument } from '@/models/client/shop-address'
  import ComAddress from '@/components/client/common/comAddress'
  export default {
    components: {
      ComAddress
    },
    created () {
      this.requestList()
      this.shopGood()
      this.scoreList()
      if (this.table.list.length === 0 || this.table.list === null || this.table.list === undefined) {
        this.dialogAdd = true
      }
    },
    data () {
      return {
        num: this.$route.params.num,
        detail: {},
        dataList: [],
        showAll: false,
        address: '',
        table: {
          loading: true,
          list: []
        },
        addForm: [],
        form: new AddFormArgument(),
        radio: '',
        addressId: '',
        convertVisible: false,
        dialogVisible: false,
        dialogAdd: false,
        formDate: {},
        editFlag: false
      }
    },
    computed: {
      showList () {
        if (this.showAll === false) {
          var showList = []
          if (this.table.list.length > 2) {
            for (let i = 0; i < 2; i++) {
              showList.push(this.table.list[i])
            }
          } else {
            showList = this.table.list
          }
          return showList
        } else {
          return this.table.list
        }
      },
      word () {
        if (this.showAll === false) {
          return '展开全部 ∨'
        } else {
          return '收起 ∧'
        }
      }
    },
    methods: {
      scoreList () {
        scoreApi.scoreList(response => {
          let status = response.data.code
          let body = response.data.data
          if (status === '200') {
            this.score = body
          } else {
            this.score = []
          }
        })
      },
      add () {
        this.dialogVisible = true
        this.dialogAdd = false
      },
      shopGood () {
        goodApi.productGood({id: this.$route.params.id}, response => {
          let status = response.status || 0
          let body = response.data || {}
          if (status === 200 || status === 204) {
            this.dataList = body
            this.detail = this.dataList
          }
        })
      },
      submitForm (form) {
        this.table.list.push(form)
      },
      verifyOrder () {
        this.form.goodId = this.detail.id
        this.form.amount = this.num
        this.form.addressId = this.addressId
        Api.addItem({form: this.form}, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status >= 200 && status <= 204) {
            this.addForm.unshift(body)
            this.$message.success('兑换成功')
            this.$router.push({name: 'order-details', params: {id: body.id}})
          } else {
            this.$message.error(body.error || '请核实信息是否正确')
          }
        })
      },
      addOrder () {
        let at = this.detail.exchangeScore * this.num
        let all = this.score.currentScore
        if (at < all) {
          this.convertVisible = true
        } else {
          this.$message.error('积分余额不足')
        }
      },
      requestList () {
        Api.getAll(response => {
          let status = response.status
          let body = response.data.list
          if (status >= 200 && status <= 204) {
            this.table.list = body
            this.table.list.forEach((item, index) => {
              if (item.isDefault === 1) {
                this.radio = index
                this.address = (item.province + ' ' + item.city + ' ' + item.area + ' ' + item.street + ' ' + '( ' + item.name + ' 收 )' + ' ' + item.mobile).toString()
                this.addressId = item.id
              }
            })
          } else {
            this.table.list = []
          }
        })
      },
      getTime (index) {
        this.table.list.forEach((item, ind) => {
          if (index === ind) {
            this.radio = ind
            this.address = (item.province + ' ' + item.city + ' ' + item.area + ' ' + item.street + ' ' + '( ' + item.name + ' 收 )' + ' ' + item.mobile).toString()
            this.addressId = item.id
          }
        })
      },
      handleClick (idx, data) {
        this.formDate = {}
        this.dialogVisible = true
        data.address = [data.province, data.city, data.area]
        this.formDate = Object.assign({'index': idx}, data)
        this.editFlag = true
      },
      setDefault (idx) {
        let id = this.table.list[idx].id
        Api.setDefault(id, response => {
          let status = response.status
          if (status >= 200 && status <= 204) {
            this.table.list.forEach((item, index) => {
              if (idx === index) {
                this.table.list[idx].isDefault = 1
              } else {
                this.table.list[index].isDefault = 0
              }
            })
            this.$message.success('设置默认成功')
            this.requestList()
          } else {
            this.$message.error('设置默认失败')
          }
        })
      },
      handleEdit (data) {
        if (this.editFlag) {
          this.table.list.splice(data.index, 1, data)
        } else {
          this.table.list.push(data)
        }
        this.dialogVisible = false
        this.formDate = {}
      },
      close () {
        this.dialogVisible = true
        this.formDate = {}
        this.editFlag = false
      }
    }
  }
</script>

<style scoped="scoped" lang="scss">
  .confirm {
    width: 1010px;
    min-height: 1000px;
    padding: 20px;
    box-sizing: border-box;
    background: white;
    border: 1px solid #ddd;
    .c-title {
      width: 900px;
      > span {
        float: right;
        cursor: pointer;
        >a{
          color: #085ECC;
          font-size: 14px;
        }
      }
    }
    .c-add {
      width: 900px;
      min-height: 100px;
      font-size: 14px;
      color: #666;
      border-bottom: 1px solid #ddd;
      overflow: hidden;
      zoom: 1;
      padding-bottom: 30px;
      box-sizing: border-box;
      .c-text {
        height: 32px;
        line-height: 32px;
        float: left;
      }
      .c-wrap {
        width: 738px;
        float: left;
        .c-con {
          width: 738px;
          min-height: 32px;
          padding: 8px;
          box-sizing: border-box;
          word-break: break-all;
          word-wrap: break-word;
          cursor: pointer;
          margin-bottom: 10px;
          &:hover {
            color: #085ECC;
          }
          &:hover .handle {
            display: block;
          }
          .con {
            width: 600px;
            min-height: 32px;
            float: left;
            padding: 0 10px;
            box-sizing: border-box;
            word-break: break-all;
            word-wrap: break-word;
          }
          .handle {
            width: 120px;
            float: right;
            display: none;
          }
        }
        .show-more {
          cursor: pointer;
          font-size: 12px;
          margin-left: 45px;
        }
      }
    }
    .new-add {
      padding: 20px 98px;
      box-sizing: border-box;
      font-size: 14px;
      color: #085ECC;
      cursor: pointer;
    }
    .c-order {
      width: 900px;
      height: 100%;
      margin-top: 50px;
      .c-msg {
        width: 100%;
        min-height: 200px;
        .msg-title {
          width: 100%;
          height: 30px;
          list-style: none;
          padding: 0 25px;
          box-sizing: border-box;
          > li {
            float: left;
            font-size: 14px;
            color: #333;
            text-align: center;
          }
          li:nth-child(1) {
            width: 400px;
            text-align: left;
          }
          li:nth-child(2) {
            width: 150px;
          }
          li:nth-child(3) {
            width: 150px;
          }
          li:nth-child(4) {
            width: 150px;
          }
        }
        .msg-con {
          height: 138px;
          list-style: none;
          padding: 25px;
          box-sizing: border-box;
          background: #f9f9f9;
          border-bottom: 10px solid white;
          overflow: hidden;
          zoom: 1;
          position: relative;
          > li {
            float: left;
            font-size: 14px;
            color: #666;
          }
          li:nth-child(1) {
            width: 400px;
            .msg-pic {
              width: 80px;
              height: 80px;
              float: left;
              background: white;
              >img{
                width: 100%;
                height: 100%;
              }
            }
            .msg-text {
              width: 300px;
              float: left;
              margin-left: 20px;
              word-break: break-all;
              word-wrap: break-word;
            }
          }
          li:nth-child(2) {
            width: 150px;
            text-align: center;
            color: #E4393C;
          }
          li:nth-child(3) {
            width: 150px;
            text-align: center;
            .tig {
              font-size: 12px;
              color: #F56C6C;
            }
            .repertory {
              font-size: 12px;
            }
          }
          li:nth-child(4) {
            width: 150px;
            text-align: center;
            color: #E4393C;
          }
          li:nth-child(5) {
            position: absolute;
            left: 50%;
            bottom: 20px;
          }
          li:nth-child(6) {
            position: absolute;
            left: 788px;
            bottom: 20px;
            color: #E4393C;
          }
        }
        .msg-foot {
          margin: 0;
          padding: 20px;
          box-sizing: border-box;
          min-height: 64px;
          list-style: none;
          background: #f9f9f9;
          > li {
            font-size: 12px;
            color: #666;
            float: left;
          }
          li:nth-child(1) {
            width: 48px;
          }
          li:nth-child(2) {
            width: 600px;
            word-break: break-all;
            word-wrap: break-word;
            padding: 0 20px 0 5px;
            box-sizing: border-box;
          }
          li:nth-child(3) {
            width: 210px;
            padding-left: 10px;
            box-sizing: border-box;
            font-size: 14px;
            > span {
              color: #E4393C;
              font-size: 18px;
            }
          }
        }
        .msg-btn {
          width: 180px;
          height: 40px;
          background: rgba(23, 112, 230, 1);
          border-radius: 4px;
          outline: none;
          border: none;
          color: white;
          float: right;
          margin: 20px 45px 0 0;
          cursor: pointer;
          &:hover {
            background: #4a98ff;
            transition-duration: 0.5s;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/client/ConfirmOrder.vue